import * as d3 from 'd3';

export const draw_middle_text = ({svg, x, y, data, text_offset, end_datetime_string}) => {
    const time_parse = d3.timeParse('%Y-%m-%d %H:%M:%S')
    const end_datetime = time_parse(end_datetime_string)
    
    const is_data_too_much = data.length > 13

    svg.selectAll('g.middle_text')
        .data(data)
        .enter()
        .append('g')
        .append('text')
        .attr('id', 'middle_text')
        .attr('x', x(end_datetime) / 2)
        .attr('y', d => y(d.value) + text_offset)
        .style('fill', '#8d8e8d')
        .style('font-size', is_data_too_much ? '0.75rem' : '1rem')
        .text(d => d.text);
}

export const draw_wind_direction_middle_text_background = (d3_options) => {
    const middle_text_y_list = _get_middle_text_y_list()
    const should_draw_background_callback = (i) => {
        return [0, 3].includes(i % 4) && i !== middle_text_y_list.length-1
    }
    _draw_background_layer(middle_text_y_list, should_draw_background_callback, d3_options)
}

export const draw_wind_tier_middle_text_background = (d3_options) => {
    const middle_text_y_list = _get_middle_text_y_list()
    const should_draw_background_callback = (i) => {
        return i % 2 === 0 && i !== middle_text_y_list.length-1
    }
    _draw_background_layer(middle_text_y_list, should_draw_background_callback, d3_options)
}

const _get_middle_text_y_list = () => {
    return [...document.querySelectorAll('#middle_text')]
        .map(d => {
            const tick_height = d.getAttribute('y')
            return tick_height
        })
        .sort((prev, next) => prev - next)
}

const _draw_background_layer = (y_list, should_draw_background_callback, d3_options) => {
    const { svg } = d3_options
    const background_layer = svg.append('g')
        .attr('id', 'tier_background')

    y_list.forEach((d, i) => {
        // 考慮到陣列長度奇數時會多畫一個 橫排
        if (should_draw_background_callback(i)) {
            const tick_rect_height = y_list[i + 1] - y_list[i];
            _draw_background({
                ...d3_options,
                ...{
                    background_layer,
                    height: tick_rect_height, 
                    start_y: y_list[i]
                }
            })
        }

        _draw_divide_line({
            ...d3_options,
            ...{
                background_layer,
                start_y: y_list[i]
            }
        })
        
    })

    d3.selectAll('#tier_background').lower()
}

const _draw_background = ({ background_layer, width, height, margin, start_y }) => {
    background_layer.append('rect')
        .attr('fill', 'rgba(240, 240, 240, 1)')
        .attr('width', width)
        .attr('height', height) // 16 是字的高度
        .attr('x', margin.left + 1)
        .attr('y', parseFloat(start_y) + 2) // 2 類似 margin
}

const _draw_divide_line = ({ background_layer, width, margin, start_y }) => {
    background_layer.append('rect')
        .attr('id', 'tier_line')
        .attr('fill', 'rgb(191, 198, 186)')
        .attr('width', width)
        .attr('height', 2)
        .attr('x', margin.left + 1)
        .attr('y', parseFloat(start_y) + 2) // 2 類似 margin
}